import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
// import { notification } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EnterpriseGridCommon from "./Ag-Grid";

const Data360LiveStatusConfigurationGrid = ({
  rows,
  columns,
  isLoading,
  onCellValueChanged,
  setSelectedParams,
  selectedParams,
  onSelectedParamsChange,
}) => {
  const toggleProjectListState = useSelector(
    (state) => state?.switchThemeReducer?.toggleProjectList
  );

  const toggleProjectDetailsState = useSelector(
    (state) => state?.switchThemeReducer?.toggleProjectDetails
  );

  let heightValue;

  if (!toggleProjectDetailsState && toggleProjectListState) {
    heightValue = -395;
  } else if (toggleProjectDetailsState && !toggleProjectListState) {
    heightValue = -350;
  } else if (!toggleProjectDetailsState && !toggleProjectListState) {
    heightValue = -275;
  } else if (toggleProjectDetailsState && toggleProjectListState) {
    heightValue = -470;
  }

  function resolveNested(obj, path) {
    return path.split(".").reduce((o, key) => (o ? o[key] : undefined), obj);
  }

  const unitsCommonFilter = {
    pivot: true,
    floatingFilter: true,
    filter: "agMultiColumnFilter",
    filterParams: {
      maxNumConditions: 1,
      filters: [
        {
          filter: "agNumberColumnFilter",
          filterParams: {
            valueFormatter: (params) => {
              return Number(params.value);
            },
            maxNumConditions: 1,
          },
        },
      ],
    },
    valueGetter: (params) => {
      const value = resolveNested(params.data, params.colDef.field);
      if (value === "" || value === null || value === undefined) return null;
      return Number(value);
    },
    cellEditor: "agNumberCellEditor",
    cellEditorParams: {
      allowDecimals: true,
      decimalSeparator: ".",
      precision: 2,
    },
    valueParser: (params) => {
      const value = params.newValue;
      if (value === "" || value === null || value === undefined) {
        return null;
      }
      const parsed = Number(value);
      return isNaN(parsed) ? null : parsed;
    },
    cellRenderer: (params) => {
      if (params.value === 0)
        return <div className="custom-input-field-status-configuration">0</div>;
      if (
        params.value === "" ||
        params.value === null ||
        params.value === undefined
      )
        return (
          <div className="custom-input-field-status-configuration">{""}</div>
        );
      return (
        <div className="custom-input-field-status-configuration">
          {params.value}
        </div>
      );
    },
    pivotComparator: (a, b) => b.localeCompare(a),
  };

  const [columnDefs, setColumnDef] = useState([
    {
      headerName: "Parameter",
      field: "parameter",
      key: "parameter",
      pinned: "left",
      minWidth: 150,
      flex: 1,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      cellRenderer: (params) => {
        const param = params.data.parameter
          .split("(")[0]
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "_");
        if (selectedParams && selectedParams[param]) {
          params.node.setSelected(true);
        }
        return params.value;
      },
    },
  ]);

  useEffect(() => {
    setColumnDef([
      {
        headerName: "Parameter",
        field: "parameter",
        key: "parameter",
        pinned: "left",
        minWidth: 150,
        flex: 1,
        pivot: true,
        floatingFilter: true,
        filter: "agMultiColumnFilter",
        filterParams: {
          maxNumConditions: 1,
          cellHeight: 30,
        },
        pivotComparator: (a, b) => b.localeCompare(a),
        cellRenderer: (params) => {
          const param = params.data.parameter
            .split("(")[0]
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_");
          if (selectedParams && selectedParams[param]) {
            params.node.setSelected(true);
          }
          return params.value;
        },
      },
      ...columns?.map((ite) => ({
        headerName: ite.columnName,
        field: ite.value,
        key: ite.value,
        minWidth: 150,
        flex: 1,
        editable: true,
        ...unitsCommonFilter,
      })),
    ]);
  }, [columns, selectedParams]);

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }
    return params.value;
  };

  return (
    <div
      className="ag-theme-alpine slog-grid-container"
      style={{ width: "100%" }}
    >
      <EnterpriseGridCommon
        rows={rows}
        columnDefs={columnDefs}
        isLoading={isLoading}
        exportFileName={"status-configuration"}
        processCellCallback={processCellCallback}
        heightValue={heightValue}
        slogData={true}
        onCellValueChanged={onCellValueChanged}
        disableStatusBar={true}
        showRowSelection={true}
        comingFrom={"status-configuration"}
        onRowSelected={() => {}}
        setSelectedParams={onSelectedParamsChange || setSelectedParams}
      />
    </div>
  );
};

export default Data360LiveStatusConfigurationGrid;
